import { render, staticRenderFns } from "./ModalShowText.vue?vue&type=template&id=aba79bc0&scoped=true&lang=pug&"
import script from "./ModalShowText.vue?vue&type=script&lang=ts&"
export * from "./ModalShowText.vue?vue&type=script&lang=ts&"
import style0 from "./ModalShowText.vue?vue&type=style&index=0&id=aba79bc0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba79bc0",
  null
  
)

export default component.exports